import React from "react";
import { transform_languages } from "../Transformation/Transformations";

function MeetingParticipantProfile({ meeting, t, formatDateTime, showMeetingDetails = true }) {
  const user = meeting?.follower;
  
  return (
    <div className="flex flex-col items-center">
      <img
        src={
          user?.image ||
          "https://res.cloudinary.com/do6t8sxgo/image/upload/v1724686661/Nobody_bao3i5.svg"
        }
        alt="UserImage"
        className="rounded-full boder-solid border-[10px] border-[var(--brand)] w-[200px] h-[200px] md:w-[200px] md:h-[200px] xl:w-[300px] xl:h-[300px]"
      />
      <div className="text-3xl font-semibold mt-8">
        {user?.first_name + " " + user?.last_name}
      </div>
      <div className="text-xl font-normal mt-2">
        {t(transform_languages(meeting?.teaching_language))}
      </div>
      {showMeetingDetails && (
        <div className="flex flex-col mt-4 items-center gap-4">
          <div className="flex">
            <div className="text-2xl font-semibold">
              {t("confirmation_card.dt")}
            </div>
            <div className="text-2xl font-normal">
              {" "}
              {formatDateTime(meeting?.meeting_happen_at)}
            </div>
          </div>
          <div className="flex">
            <div className="text-2xl font-semibold">
              {t("confirmation_card.du")}
            </div>
            <div className="text-2xl font-normal">
              {" "}
              {meeting?.meeting_length} {t("generic.minute")}
            </div>
          </div>
          <div className="flex">
            <div className="text-2xl font-semibold">
              {t("confirmation_card.lang")}
            </div>
            <div className="text-2xl font-normal">
              {t(transform_languages(meeting?.teaching_language))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MeetingParticipantProfile;
